<section class="background-color integration u-padding-16">
    <header class="integration__header line-height-24 u-font-size-16">
      {{template?.name}}
      <a href="https://www.vqvelocity.com/" target="_blank" rel="noopener noreferrer">
        <mat-icon style="font-size: 18px; line-height: 1; vertical-align: middle">open_in_new</mat-icon>
      </a>
      <span class="integration__active">
        <mat-chip-list>
          <mat-chip color="primary">
            <mat-icon class="circle-icon {{getActiveIconClass()}}">circle</mat-icon>
            {{getActiveIconText()}}
          </mat-chip>
        </mat-chip-list>
      </span>
      <div class="integration__subheader line-height-16 u-font-size-14">
        <a href="{{template?.website}}" target="_blank">Helpdesk</a>
      </div>
    </header>
    <div class="integration__content border-color background-color-intense u-margin-top-20 u-margin-bottom-8">
      <form class="o-flex o-flex--column u-margin-bottom-m" [formGroup]="integrationForm">
        <mat-form-field floatLabel="always" appearance="outline">
          <mat-label>Subscription</mat-label>
          <mat-select placeholder="Select a subscription to assign tests to and then click on 'Activate'" formControlName="purchase" required>
            <mat-option *ngFor="let purchase of purchases" [value]="purchase.id">{{ purchase.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          Setting up this integration with Velocity - Vision Quest Virtual will require the API key shown at the top of this page
        </div>
      </form>
    </div>
    <div class="integration__buttons">
      <button mat-raised-button color="primary" [disabled]="!canSave()" (click)="save()">{{getSaveButtonText()}}</button>
      <button mat-raised-button *ngIf="showIntegrationActiveFlag$.value" (click)="toggleActivation()">{{getToggleActivationButtonText()}}</button>
    </div>
  </section>
  